var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{
  'style-round': _vm.cornerStyle === 'round',
  'style-square': _vm.cornerStyle === 'square',
  fontLoaded: _vm.fontLoaded
}},[_c('button',{style:({ fontFamily: _vm.fontFamilyCSS }),on:{"click":_vm.followNextLink}},[_vm._v(_vm._s(_vm.buttonTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }